export default "__VITE_ASSET__1fe7b5e1__"